module.exports = __webpack_public_path__ + "img/payment-dana.0cf8f0ee.png";